/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Rounds_Seating_MovingInputs */



/**
* | output |
* | --- |
* | "Moving {name} — tap a seat to swap, or an open seat to move" |
*
* @param {Rounds_Seating_MovingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_seating_moving = /** @type {((inputs: Rounds_Seating_MovingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Seating_MovingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Déplacement de ${i?.name} — appuyez sur un placement pour échanger, ou sur un placement libre pour déplacer`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Moviendo a ${i?.name} — pulse un asiento para intercambiar, o un asiento libre para mover`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Movendo ${i?.name} — toque em um assento para trocar, ou em um assento livre para mover`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Spostamento di ${i?.name} — tocca un posto per scambiare, o un posto libero per spostare`)
	return /** @type {LocalizedString} */ (`Moving ${i?.name} — tap a seat to swap, or an open seat to move`)
});